import { AutogenModelCustomerRoutingGuide, AutogenRowCustomerRoutingGuide } from "./autogen/AutogenModelCustomerRoutingGuide";

export class ModelCustomerRoutingGuide extends AutogenModelCustomerRoutingGuide<RowCustomerRoutingGuide> {
    constructor() {
        super(RowCustomerRoutingGuide);
    }
}

export class RowCustomerRoutingGuide extends AutogenRowCustomerRoutingGuide {
}